import { createDefaultTyrann } from '@apis/common';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const newPasswordBody = t.type({
  new_password1: t.string,
  new_password2: t.string,
  uid: t.number,
});

export const newPasswordResponseBody = t.type({
  detail: t.string,
});

export type NewPasswordBody = t.TypeOf<typeof newPasswordBody>;

export const resetPasswordApis = createDefaultTyrann({
  '/password/reset/confirm/': {
    post: {
      body: newPasswordBody,
      response: {
        200: newPasswordResponseBody,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
});
